import type { FaireProductEntity } from "../../entity_types/product";

export const p_2uvefsum58: FaireProductEntity = {
  token: "p_2uvefsum58",
  type: "product",
  name: "Sampler: Canned Coffee Soda",
  brandToken: "b_f358njub53",
  brandName: "Comeback",
  imageUrl: "https://cdn.faire.com/fastly/eb7328d01a33783d5b739a9a409412ced83b3a27074a176f715c01adedc5671a.jpeg",
  galleryImageUrls: [],
  priceDollars: 18,
  description: "Try out a mixed 6 pack of each of our 3 coffee soda flavors before you commit to a whole case!\n\nIncluded:\n\n2 cans of Southern Style\n2 cans of Field Day\n2 cans of Greetings From ",
  tags: [],
  msrpDollars: 36,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:32.363Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
